<template>
    <div id="wall-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Стены</div>
        <div class="sidebar-text-area">Обведите контуром плоскость <span class="red-text bold-text">стены</span>, поочерёдно расставляя точки, соответствующие углам плоскости на изображении в рабочей области. Плоскость будет считаться завершенной, если замкнуть контур.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/wall_outline.svg')"/>
        </div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "WallsSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
